import React from "react";
import { Button, Drawer, IconButton, Avatar } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import slice from "../states/drawer/slice";
import State from "../states/State";
import LockIcon from '@material-ui/icons/Lock';
import CloseIcon from '@material-ui/icons/Close';
import PeDetailInfo from '../components/PeDetailInfo';
import { reset } from "redux-form";
import { useHistory } from "react-router-dom";
import useStyles from "../styles/styles";
import sliceShell from '../states/shell/slice';
import useToken from "../hooks/UseToken";


type PeDrawerMenuProps = {};

const PeDrawerMenu: React.FC<PeDrawerMenuProps> = props => {

    const classes = useStyles();
    const state = useSelector((state: State) => ({
        drawer: state.drawer,
        shell: state.shell,
    }));
    const { isOpen } = state.drawer;
    const { isAuth } = state.shell;

    const dispatch = useDispatch();
    const history = useHistory();
    const search = history.location.search;
    const { token, clearToken } = useToken();

    const handleClose = () => {
        dispatch(slice.actions.updateDrawer(false));
    };

    const startOver = ()=>{
        dispatch(reset('battery-form'));
        handleClose();
    }   
    const handleLoginClick = () => {
        history.push("/login" + (search ? `?callback=/master${search}` : ""));
    }

    const handleLogoutClick = () => {
        clearToken();
        dispatch(sliceShell.actions.updateIsAuth(false));
        history.push("/" + search);
    }

    return (
        <div>
            <Drawer classes={{ paper: classes.WrapperDrawer }} anchor={'right'} open={isOpen} onClose={handleClose}>
                <div className={classes.wrapPadding}>
                    <div className={classes.paddingButton}>
                        {isAuth ? <div style={{display: 'flex', alignItems: 'center'}}>
                            <Avatar style={{marginRight: '10px'}}>{token ? token.user.first_name ? token.user.first_name.charAt(0) : 'A' : 'A'}</Avatar>
                            <Button variant="outlined"
                                size="small"
                                className={classes.PeDrawerMenu_button}
                                style={{color: '#a0a0a0', borderColor: '#cbc8c8', background: '#f2f2f'}}
                                onClick={handleLogoutClick}>
                                LOG OUT
                            </Button>
                        </div> : <Button variant="outlined"
                        size="small"
                        className={classes.PeTopBar_button}
                        style={{color: '#d21919', borderColor: '#d21919'}}
                        onClick={handleLoginClick}
                        startIcon={<LockIcon />}>
                            LOGIN
                        </Button>}
                        <Button variant="outlined"
                            size="small"
                            className={classes.PeDrawerMenu_button}
                            style={{color: '#a0a0a0', borderColor: '#cbc8c8', background: '#f2f2f'}}
                            onClick={startOver}>
                            START OVER?
                        </Button>
                        <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClose}><CloseIcon /></IconButton>
                    </div>
                    <PeDetailInfo />
                </div>
            </Drawer>
        </div>
    );
}

export default PeDrawerMenu;